export enum AudienceSourceType {
	FileUpload = 1,
	Hris = 2,
	Hierarchy = 3,
}
